"use client";

import { useEffect } from "react";
import { Button } from "@/components/ui/button";

const RouteError = ({
  error,
  unstable_retry,
  title = "Noe gikk galt",
  description = "Det oppstod en midlertidig feil under lasting av innholdet.",
}) => {
  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <div className="container max-w-(--breakpoint-md) mt-8 mb-10">
      <div className="rounded-lg border border-border/60 bg-background p-6 md:p-8">
        <h1 className="text-2xl font-black md:text-3xl">{title}</h1>
        <p className="mt-3 text-base text-muted-foreground">{description}</p>

        {error?.digest && (
          <p className="mt-4 text-sm text-muted-foreground">
            Feilkode: {error.digest}
          </p>
        )}

        <Button className="mt-6" onClick={() => unstable_retry()}>
          Prøv igjen
        </Button>
      </div>
    </div>
  );
};

export default RouteError;
